/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "cash": {
        "nested": {
          "gambit": {
            "nested": {
              "api": {
                "nested": {
                  "v1": {
                    "nested": {
                      "checkdeposit": {
                        "nested": {
                          "ReturnReason": {
                            "values": {
                              "RETURN_REASON_UNSPECIFIED": 0,
                              "RETURN_REASON_UNKNOWN": 1,
                              "RETURN_REASON_INSUFFICIENT_FUNDS": 2,
                              "RETURN_REASON_UNCOLLECTED_FUNDS_HOLD": 3,
                              "RETURN_REASON_STOP_PAYMENT": 4,
                              "RETURN_REASON_CLOSED_ACCOUNT": 5,
                              "RETURN_REASON_UNABLE_TO_LOCATE_ACCOUNT": 6,
                              "RETURN_REASON_FROZEN_ACCOUNT": 7,
                              "RETURN_REASON_STALE_DATED": 8,
                              "RETURN_REASON_POST_DATED": 9,
                              "RETURN_REASON_ENDORSEMENT_MISSING": 10,
                              "RETURN_REASON_ENDORSEMENT_IRREGULAR": 11,
                              "RETURN_REASON_SIGNATURE_MISSING": 12,
                              "RETURN_REASON_SIGNATURE_IRREGULAR": 13,
                              "RETURN_REASON_NON_CASH_ITEM": 14,
                              "RETURN_REASON_ALTERED_OR_FICTITIOUS_ITEM": 15,
                              "RETURN_REASON_UNABLE_TO_PROCESS": 16,
                              "RETURN_REASON_EXCEEDS_STATED_MAX_VALUE": 17,
                              "RETURN_REASON_NOT_AUTHORIZED": 18,
                              "RETURN_REASON_BRANCH_ACCOUNT_SOLD": 19,
                              "RETURN_REASON_REFER_TO_MAKER": 20,
                              "RETURN_REASON_EXCEEDS_ALLOWABLE_NUMBER_OF_PRESENTMENTS": 21,
                              "RETURN_REASON_UNUSABLE_IMAGE": 22,
                              "RETURN_REASON_INVALID_IMAGE": 23,
                              "RETURN_REASON_CANNOT_DETERMINE_AMOUNT": 24,
                              "RETURN_REASON_REFER_TO_IMAGE": 25,
                              "RETURN_REASON_DUPLICATE_PRESENTMENT": 26,
                              "RETURN_REASON_FORGERY": 27,
                              "RETURN_REASON_ACH_ADMIN_RETURN": 28,
                              "RETURN_REASON_WARRANTY_BREACH": 29,
                              "RETURN_REASON_RCC_WARRANTY_BREACH": 30,
                              "RETURN_REASON_FORGED_AND_COUNTERFEIT_WARRANTY_BREACH": 31,
                              "RETURN_REASON_RETIRED_OR_INELIGIBLE_ROUTUNG_NUMBER": 32,
                              "RETURN_REASON_DEPOSIT_ADJUSTMENT": 33
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.cash?.nested?.gambit?.nested?.api?.nested?.v1?.nested?.checkdeposit?.nested?.ReturnReason) {
  $root.addJSON(jsonData);
}

/**
 * next id: 34
 *
 * SOURCE ReturnReason @ squareup/cash/gambit/api/v1/checkdeposit/return_reason.proto at 8:1
 */
export const ReturnReason = $root.lookupEnum('squareup.cash.gambit.api.v1.checkdeposit.ReturnReason').values;